import { useEffect, useState } from "react";
import useClinicalHistoryLoader from "./hooks/useClinicalHistoryLoader";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import ListClinicalHistory from "./ListClinicalHistory";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom";
import EmptyCalendar from "src/shared/components/notFoundData/EmptyCalendar";

const ClinicalHistoryView = () => {
  const {
    clinicalHistory,
    filteredClinicalHistory,
    setFilteredClinicalHistory,
    loadClinicalHistory,
    loading,
    serviceCodes,
  } = useClinicalHistoryLoader();

  const [serviceSelected, setServiceSelected] = useState(null);

  const applyFilters = () => {
    let filtered = [...clinicalHistory];

    if (serviceSelected) {
      filtered = filtered.filter(
        (history) => history.codigoServicio === serviceSelected.codigoServicio
      );
    }
    console.log(filtered, "filtered");
    setFilteredClinicalHistory(filtered);
  };

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicalHistory, serviceSelected]);

  useEffect(() => {
    loadClinicalHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!filteredClinicalHistory.length) return <EmptyCalendar text={"No tiene registros anteriores"} />;
  
  return (
    <Stack>
      <Box display={"flex"} gap={2} mb={2} flexWrap="wrap">
        <div>
          <InputLabelCustom htmlFor="autocomplete-servicio" text="Servicio" />
          <Autocomplete
            disablePortal
            size="small"
            options={serviceCodes}
            getOptionLabel={(option) => option.servicio || ""}
            value={serviceSelected}
            sx={{ width: 300 }}
            onChange={(_, newValue) => {
              setServiceSelected(newValue);
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Filtrar servicio" />
            )}
          />
        </div>
      </Box>

      <ListClinicalHistory
        clinicalHistory={filteredClinicalHistory}
        loading={loading}
      />
    </Stack>
  );
};

export default ClinicalHistoryView;
